import axios from "axios";
import { SYS_CONFIG } from '../Utils/Sysconfig'


const baseURL = SYS_CONFIG.localBaseUrl
const addId = (baseURL, endpoint, id) => {
    const url = id ? `${baseURL}/${endpoint}/${id}` : `${baseURL}/${endpoint}`;
    return url;
};
export default function generateReport(method, endPoint, id, data) {
    const accessToken = localStorage.getItem("accessToken");

    let url = addId(
        baseURL,
        endPoint,
        id
    );

    var config = {
        method: method,
        url: url,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        responseType: 'arraybuffer',
        data: data,
        // timeout:300000
    };
    return new Promise((resolve, reject) => {
        axios(config)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                if(error.response.status===401){
                reject("access denied")
                }
                reject(error.response);
            });
    });
}